import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { businessInfo, instagramHandle } from '../data/mock';
import { Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'home', label: t.nav.home },
    { id: 'about', label: t.nav.about },
    { id: 'services', label: t.nav.services },
    { id: 'gallery', label: t.nav.gallery },
    { id: 'booking', label: t.nav.booking },
    { id: 'contact', label: t.nav.contact },
  ];

  return (
    <footer className="bg-stone-950 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/lvf4tsch_a-removebg-preview.png"
              alt="AB Nail Lounge"
              className="h-20 w-auto object-contain mb-4 invert"
            />
            <p className="text-stone-400 text-sm leading-relaxed mb-4">
              {language === 'fr'
                ? "L'art de la beauté des ongles à Moncton. Des designs uniques et personnalisés pour sublimer vos mains."
                : 'The art of nail beauty in Moncton. Unique and personalized designs to enhance your hands.'}
            </p>
            <a
              href={businessInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-rose-400 hover:text-rose-300 transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span>@{instagramHandle}</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-medium mb-4">Navigation</h4>
            <nav className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-stone-400 hover:text-rose-400 text-sm text-left transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-lg font-medium mb-4">{t.footer.location}</h4>
            <address className="not-italic text-stone-400 text-sm leading-relaxed">
              <p>{businessInfo.address}</p>
              <p>{businessInfo.city}</p>
              <p className="text-stone-500">{businessInfo.building}</p>
              <p className="mt-3">{businessInfo.phone}</p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-sm">
            © {currentYear} AB Nail Lounge. {t.footer.rights}.
          </p>
          <p className="text-stone-500 text-sm flex items-center gap-1">
            {language === 'fr' ? 'Fait avec' : 'Made with'}
            <Heart className="w-4 h-4 text-rose-400 fill-rose-400" />
            {language === 'fr' ? 'à Moncton' : 'in Moncton'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
